module.exports = __webpack_public_path__ + "img/ca.0672d51a.svg";